module.exports = __webpack_public_path__ + "static/media/resize.22d38eeb.gif";